import { Box } from '@factorialco/deprecated-design-system'
import { ResourceHeader } from '@factorialco/factorial-one-react/dist/experimental'
import { Add } from '@factorialco/factorial-one-react/icons/app'

import i18n from 'modules/core/lib/i18n'

type Props = {
  title: string
  description?: string
  onCreateButton: () => void
  removePadding?: boolean
}

export const FoldersHeader = ({ title, description, onCreateButton, removePadding }: Props) => {
  const action = {
    label: i18n.t('settings.folders.form.add.button'),
    icon: Add,
    onClick: onCreateButton,
  }

  const header = <ResourceHeader title={title} description={description} primaryAction={action} />

  if (!removePadding) return header

  return <Box style={{ margin: '-20px' }}>{header}</Box>
}
